import React, { useEffect } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsVoteScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const buttonStyle = {
        width: "80%",
        padding: "12px",
        marginBottom: "10px",
        fontSize: "16px",
    };

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <div className="divtext_slov"><b>Голосуйте</b></div>
            <br />

            {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
                <React.Fragment key={index}>
                    <button
                        type="button"
                        style={buttonStyle}
                        onClick={() => props.sendMessage(`sendtoserver|slov\\buttonchosen\\voteforcard\\${index}`)}
                    >
                        Открытка {index}
                    </button>
                    <br />
                </React.Fragment>
            ))}
        </div>
    );
};